const ALLOWED_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/webp'];

export const validImage = (file) =>
  file &&
  ALLOWED_IMAGE_TYPES.includes(file.type) &&
  file.size < 5000 * 1000;
